<template>
  <b-card>
    <div class="d-flex justify-content-between flex-wrap">
      <b-form
        class="d-flex align-items-center  "
        @submit.prevent="onSearch"
      >
        <b-form-input v-model.trim="search" />
        <b-button variant="primary" class="ml-sm-1 mt-sm-0 ml-50" type="submit">
          جستجو
        </b-button>
      </b-form>
      <div class="d-flex">
        <b-button
          class="my-1 mr-50"
          variant="outline-primary"
          :to="{ name: 'add-session' }"
        >
          ایجاد جلسه
        </b-button>
        <b-button class="my-1" variant="outline-danger" @click="removeSessions">
          حذف جلسه ها
        </b-button>
      </div>
    </div>
    <data-table
      :fields="fields"
      :items="sessions"
      :loading="loading"
      @onRowClicked="
        $router.push({
          name: 'show-session',
          params: { session_id: $event.id },
        })
      "
    >
      <template #selectuser="{ data }">
        <b-form-checkbox
          v-model="removeSessionsData"
          :value="data.item.id"
        ></b-form-checkbox>
      </template>
      <template #id="{ data }">
        {{ data.item.id }}
      </template>

      <template #name="{ data }"
        ><div style="white-space: nowrap">{{ data.item.name }}</div></template
      >
      <!-- <template #available_at="{ data }">
        <b-badge variant="light-primary">
          {{ data.item.available_at ? calcDate(data.item.available_at) : "-" }}
        </b-badge></template
      > -->

      <template #status="{ data }">
        <b-badge :variant="data.item.active ? 'light-success' : 'light-danger'"
          >{{ data.item.active ? "فعال" : "غیر فعال" }}
        </b-badge></template
      >

      <template #actions="{ data }">
        <div class="d-flex  ">
          <b-button
            size="sm"
            variant="flat-primary"
            :to="{
              name: 'show-session',
              params: { session_id: data.item.id },
            }"
          >
            <feather-icon icon="EyeIcon" />
            <span class="ml-50">مشاهده</span>
          </b-button>
          <b-button
            size="sm"
            variant="flat-warning"
            :to="{
              name: 'edit-session',
              params: { id: data.item.id },
            }"
          >
            <feather-icon icon="EditIcon" />
            <span class="ml-50">ویرایش</span>
          </b-button>

          <b-button
            size="sm"
            variant="flat-danger"
            @click="removeSession(data.item)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="ml-50">حذف</span>
          </b-button>
        </div>
      </template>
    </data-table>
    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div class="col-md-3 pl-0">
        <b-form-checkbox v-model="selectAll" class="ml-2">
          انتخاب همه</b-form-checkbox
        >
      </div>
      <div class="col-md-6 d-flex justify-content-md-center align-items-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BAvatar,
  BCard,
  BDropdownItem,
  BForm,
  BDropdown,
  BFormInput,
  BFormCheckbox,
  BFormGroup,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    VBModal,
    BBadge,
    BPagination,
    BLink,
    BForm,
    BFormGroup,
    BAvatar,
    BCard,
    BDropdownItem,
    BDropdown,
    BFormInput,
    BFormCheckbox,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      selectAll: false,
      removeSessionsData: [],
      sessions: [],
      choosenPage: 1,
      loading: false,
      url: "",
      search: "",
      currentPage: 1,
      pagination: {},
      visible: false,
      fields: [
        { key: "selectuser", label: "" },
        { key: "id", label: "شناسه" },
        { key: "name", label: "نام" },

        { key: "status", label: "وضعیت" },
        { key: "actions", label: "عملیات" },
      ],
    };
  },
  watch: {
    selectAll: {
      handler(val) {
        val
          ? (this.removeSessionsData = this.sessions.map(
              (semester) => semester.id
            ))
          : (this.removeSessionsData = []);
      },
      immediate: true,
    },
    removeSessionsData: {
      handler(val) {
        val.length == this.sessions.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    $route: {
      handler(val) {
        this.removeSessionsData = [];
        this.getSessions();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "sessions",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val && this.$route.query.key) {
        this.$router.push({
          name: "sessions",
        });
      }
    },
  },
  async created() {
     if (this.$route.query.key) {
      this.$router.push({
        name: "sessions",
      });
    }
    this.url = `/panel/sessions`;
    await this.getSessions();
  },
  methods: {
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: "sessions",
          query: {
            key: this.search,
          },
        });
      }
    },
    finalAmount(item) {
      let finalAmount = 0;
      if (item.percentage) {
        finalAmount =
          Number(item.amount) -
          (Number(item.amount) * Number(item.rebate)) / 100;
      } else {
        finalAmount = Number(item.amount) - Number(item.rebate);
      }

      return finalAmount > 0
        ? this.decodePersianName(String(parseInt(finalAmount)))
        : "0";
    },
    removeSession(item) {
      this.$bvModal
        .msgBoxConfirm("آیا میخواهید این مورد حذف شود ؟", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "بله",
          cancelTitle: "خیر",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/sessions/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                this.removeSessionsData = [];
                await this.getSessions();
              } else {
                await this.$router.push({
                  name: "sessions",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "مورد با موفقیت حذف شد.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "مشکلی پیش آمده است",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    removeSessions() {
      if (this.removeSessionsData.length) {
        this.$bvModal
          .msgBoxConfirm("آیا میخواهید موارد انتخاب شده حذف شوند ؟", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "بله",
            cancelTitle: "خیر",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await new Promise((resolve, reject) => {
                  this.removeSessionsData.map(async (session, index) => {
                    await this.$http.delete(`/panel/sessions/${session}`);
                    if (index + 1 == this.removeSessionsData.length) {
                      resolve();
                    }
                  });
                });
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removeSessionsData = [];
                  await this.getSessions();
                } else {
                  await this.$router.push({
                    name: "sessions",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "مورد با موفقیت حذف شدند.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "مشکلی پیش آمده است",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "موردی انتخاب نشده است",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async getSessions() {
      this.loading = true;
      try {
        const params = {
          per_page: 15,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
        });
        this.sessions = data.data.sessions;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
